define('viewModels/dashboards/qualityAdminDashboard/AgentActivityWidget',[
    'lib/lodash4',
    'lib/knockout',
    'services/qualityManagementService',
    'util/errorCallbackFactory',
    'viewModels/privileged/qm/policies/editors/AgentSelectorView',
    'viewModels/privileged/qm/GroupSelectorView',
    'viewModels/privileged/qm/policies/editors/TeamSelectorView',
    'viewModels/ViewModel'
], function (
        _,
        ko,
        qualityManagementService,
        errorCallbackFactory,
        AgentSelectorView,
        GroupSelectorView,
        TeamSelectorView,
        ViewModel
    ) {
    "use strict";

    var AgentActivityWidget = ViewModel.extend(function(dateRangeObservable, evaluatorId) {
        var self = this;

        self.activityDateRange = dateRangeObservable;

        self.isLoadingRows = ko.observable();

        self.agent = ko.observable();
        self.group = ko.observable();
        self.team = ko.observable();
        self.rows = ko.observableArray();
        self.isLinkToggled = ko.observable(true);

        //Set defaults for pager and footer
        self.gridOptions = ko.observable({
            pageCount: 1,
            pageNumber: 1,
            pageSize: 25
        });

        self.placeHolderText = ko.i18n.renderString("qualityAdminDashboard.agentActivity.placeholderText");

        //SubView for Agent Selector in the Agent column
        self.agentSelector = self.subView(AgentSelectorView, self.agent);
        self.groupSelector = self.subView(GroupSelectorView, self.group);
        self.teamSelector = self.subView(TeamSelectorView, self.team);

        self.getRows = function(options){
            var responseRows = [];
            self.isLoadingRows(true);

            var dates = self.activityDateRange()[0].split('/');
            options.startTime = dates[0];
            options.endTime = dates[1];

            if(evaluatorId){
                options.evaluatorUserId = evaluatorId();
            }

            qualityManagementService.getAgentActivity(options)
                .then(function (response) {
                    self.gridOptions({
                        pageCount: response.pageCount,
                        pageNumber: response.pageNumber,
                        pageSize:   !options.pageSize ? response.pageSize : options.pageSize
                    });
                    responseRows =_.map(response.entities, function(entity){
                        return {
                            name: {
                                displayName: entity.agent.name ? entity.agent.name : ko.i18n.renderString("agentDashboard.noName"),
                                isLinkToggled: self.isLinkToggled,
                                href: "#/analytics/agents/" + entity.agent.id + "/evaluations"
                            },
                            averageScore: entity.averageEvaluationScore,
                            numberOfEvaluations: entity.numEvaluations,
                            numEvaluationsExcluded: entity.numEvaluationsWithoutViewPermission
                        };
                    });
                    self.rows(responseRows);
                })
                .catch(errorCallbackFactory.createCallback({
                    namespace: 'qualityAdminDashboard.agentActivity.error'
                }))
                .finally(function() {
                    self.isLoadingRows(false);
                });
        };

        self.refreshGrid = function(incomingOptions) {
            var queryOptions = {};

            if (incomingOptions){
                if (incomingOptions.pageSize > self.gridOptions().pageSize){
                    queryOptions.pageNumber = 1;
                } else {
                    queryOptions.pageNumber = incomingOptions.pageNumber;
                }
                queryOptions.pageSize = incomingOptions.pageSize;
            }

            if (self.agent()) {
                queryOptions.agentUserId = self.agent().id;
            }

            if (self.group()){
                queryOptions.group = self.group().id;
            }

            if (self.team()) {
                queryOptions.agentTeamId = self.team().id;
            }

            self.getRows(queryOptions);
        };

        //Create grid
        self.refreshGrid();

        self.subscribe(self.activityDateRange, function () {
            self.rows([]);
            self.refreshGrid();
        });
    });
    return AgentActivityWidget;
});

